import { Box, Stack } from '@mui/material'

interface AccessGateLayoutProps {
  children: React.ReactNode
}

const AccessGateLayout: React.FC<AccessGateLayoutProps> = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      minHeight="100dvh"
      width="100%"
      px={3}
      py={4}
    >
      <Stack alignItems="center" spacing={2} width="100%" maxWidth={360} mx="auto">
        {children}
      </Stack>
    </Box>
  )
}

export default AccessGateLayout
